import { MOBILE_SCREEN_WIDTH } from 'utils/screens';
import useWindowSize from './useWindowSize';

const useIsMobile = () => {
  const isMobile = useWindowSize().width <= MOBILE_SCREEN_WIDTH;
  return isMobile;
};

export default useIsMobile;
